import { Box, Grid2, Typography } from "@mui/material";
import PageTitle from "../components/PageTitle";
import { InternalLink } from "../../shared/components/InternalLink";
import { MatchListCard } from "../components/MatchListCard";
import useUserId from "../../shared/hooks/useUserId";

export default function Matches() {
  const [uid, loading] = useUserId();

  return (
    <Box>
      <PageTitle title="Matches" />

      <Grid2 container spacing={2}>
        {uid && (
          <>
            <Grid2 size={12}>
              <MatchListCard
                label="Active Games"
                status="active"
                playerId={uid}
              />
            </Grid2>
            <Grid2 size={12}>
              <MatchListCard
                label="Pending Games"
                status="pending"
                playerId={uid}
              />
            </Grid2>
          </>
        )}
        {!uid && !loading && (
          <Typography>
            No matches here because you aren't logged in.{" "}
            <InternalLink restricted to="/game">
              Find a match
            </InternalLink>
          </Typography>
        )}
      </Grid2>
    </Box>
  );
}
